export default {
    header: {
        self: {},
        items: [{}],
    },
    aside: {
        self: {},
        items: [
            {
                title: "Dashboard",
                root: true,
                icon: "fas fa-tachometer-alt",
                page: "dashboard",
                bullet: "dot",
            },
            {
                title: "Comercial",
                root: true,
                icon: "fas fa-pen-nib",
                page: "comercial",
                bullet: "dot",
            },
            {
                title: "Contratos",
                root: true,
                bullet: "dot",
                icon: "fas fa-file-signature",
                submenu: [
                    {
                        title: "Contrato",
                        bullet: "dot",
                        page: "contrato",
                    },
                    {
                        title: "Master associado",
                        bullet: "dot",
                        page: "master-associado",
                    },
                    {
                        title: "Associados",
                        bullet: "dot",
                        page: "associado",
                    },
                ],
            },
            {
                title: "Eventos",
                root: true,
                bullet: "dot",
                icon: "fas fa-car-crash",
                submenu: [
                    {
                        title: "Eventos",
                        bullet: "dot",
                        page: "evento",
                    },
                    {
                        title: "Terceiros",
                        bullet: "dot",
                        page: "terceiro",
                    },
                ],
            },
            {
                title: "Financeiro",
                root: true,
                bullet: "dot",
                icon: "fas fa-dollar-sign",
                submenu: [
                    {
                        title: "Faturas frota/varejo",
                        bullet: "dot",
                        page: "fatura",
                    },
                    {
                        title: "Faturas garantia",
                        bullet: "dot",
                        page: "master-associado-pagamento",
                    },
                    {
                        title: "Eventos",
                        bullet: "dot",
                        page: "financeiro-evento",
                    },
                ],
            },
            {
                title: "Envolvidos",
                root: true,
                bullet: "dot",
                icon: "fas fa-address-book",
                submenu: [
                    {
                        title: "Representantes",
                        bullet: "dot",
                        page: "representante",
                    },
                    {
                        title: "Fornecedores",
                        bullet: "dot",
                        page: "fornecedor",
                    },
                ],
            },
            {
                title: "Operacional",
                root: true,
                bullet: "dot",
                icon: "fas fa-cogs",
                submenu: [
                    {
                        title: "Produtos",
                        bullet: "dot",
                        page: "produto",
                    },
                    {
                        title: "Envio de SMS/email",
                        bullet: "dot",
                        page: "envio",
                    },
                    {
                        title: "Cadastro de tags",
                        bullet: "dot",
                        page: "tag",
                    },
                    {
                        title: "Contas bancárias",
                        bullet: "dot",
                        page: "conta-bancaria",
                    },
                ],
            },
            {
                title: "Notificações",
                root: true,
                icon: "fas fa-bell",
                page: "notificacao",
                bullet: "dot",
            },
            {
                title: "Relatórios",
                root: true,
                bullet: "dot",
                icon: "fas fa-chart-pie",
                submenu: [
                    {
                        title: "Contratos",
                        bullet: "dot",
                        page: "relatorio/relatorio01",
                    },
                    {
                        title: "Faturamento",
                        bullet: "dot",
                        page: "relatorio/relatorio02",
                    },
                    {
                        title: "Eventos Associados",
                        bullet: "dot",
                        page: "relatorio/relatorio03",
                    },
                    {
                        title: "Faturas",
                        bullet: "dot",
                        page: "relatorio/relatorio04",
                    },
                    {
                        title: "Inadimplência",
                        bullet: "dot",
                        page: "relatorio/relatorio05",
                    },
                    {
                        title: "Inativos",
                        bullet: "dot",
                        page: "relatorio/relatorio06",
                    },
                    {
                        title: "Eventos Terceiros",
                        bullet: "dot",
                        page: "relatorio/relatorio07",
                    },
                    {
                        title: "Fechamento",
                        bullet: "dot",
                        page: "relatorio/relatorio08",
                    }
                ],
            },
            {
                title: "Acessos",
                root: true,
                icon: "fas fa-user-shield",
                bullet: "dot",
                submenu: [
                    {
                        title: "Usuários do sistema",
                        page: "admin",
                        bullet: "dot",
                    },
                    {
                        title: "Grupos de Acesso",
                        page: "group",
                        bullet: "dot",
                    },
                ],
            },
        ],
    },
};
